export function getTemplateIdVersionKey(
  templateId?: string,
  versionValue?: string,
): string {
  if (!templateId) return "";
  return `${templateId}:${versionValue || "Draft"}`;
}
